/**
 * ## Connection Controller
 *
 * @module src/controllers/connection
 */

"use strict";

const conf = require("../../config");

/** Connection init
 */
const config = (token, site_id, mode) => {
  let thisMode = "guestlist";
  if (mode) {
    thisMode = mode;
  }
  return {
    room: "state",
    service: "client",
    api: { version: "1.0.0" },
    credentials: {
      token,
      site_id,
      mode: thisMode,
    },

    // Socket.IO (KD Server) host parameters
    sio: {
      host: conf.vars.SOCKET_HOST,
      port: conf.vars.SOCKET_PORT,
      options: {
        autoConnect: true,
        reconnection: true,
        reconnectionAttempts: Infinity,
        reconnectionDelay: 1000,
        reconnectionDelayMax: 30000,
        randomizationFactor: 0.5,
        timeout: false,
      },
    },

    // LokiJS database configuration
    db: {
      file: "kd.json",
      options: {
        autosave: true,
        autosaveInterval: 2000,
        env: "BROWSER",
      },
    },
  };
};

module.exports = {
  config,
};



/** WEBPACK FOOTER **
 ** ./src/controllers/connection/index.js
 **/